<app-hero-courses></app-hero-courses>
<!-- <div class="first container grid">
  <div class="row my-4">
    <div class="col-xl d-flex justify-content-center align-items-center my-3">
      <img src="../../../../assets/img/educatori.png" alt="" />
    </div>
    <div class="col-xl d-flex justify-content-center align-items-center mt-5">
      <img src="../../../../assets/img/12moduli.png" alt="" />
    </div>
  </div>
</div> -->

<div class="second container grid">
  <h3 class="w-700 blue-50 text-center">
    La perfetta combinazione tra divertimento<br />
    e apprendimento.
  </h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    Perché limitarti a giocare con un drone quando puoi imparare a programmarlo?
  </p>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    Tello EDU è un drone piccolo e compatto, ma dotato di molte funzionalità
    avanzate, che lo rendono uno strumento ideale per portare l’educazione STEM
    e il pensiero computazionale all’interno delle aule scolastiche.
  </p>
</div>

<div class="third container grid">
  <div class="row">
    <div class="col text-center">
      <img
        src="../../../../assets/img/drone-1.png"
        alt="Drone"
       
        class="drone-1"
      />
    </div>
  </div>
</div>

<div class="fourth container grid">
  <h3 class="w-700 blue-50 text-center">
    Ad ogni utente il proprio linguaggio.
  </h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    Tello EDU supporta
    <span class="underline-a">diversi linguaggi di programmazione:</span> dal
    più semplice linguaggio a blocchi dell’app nativa a Scratch, da Swift a
    Python, è adatto sia per chi è alle prime armi sia per chi è già un
    programmatore esperto.
  </p>
</div>

<div class="fifth">
  <div class="row">
    <img
      src="../../../../assets/img/code-2.png"
      alt="Code Editor"
     
      class="code-2"
    />
  </div>
</div>

<app-modules [data]="modulesText"></app-modules>
<app-iscriviti></app-iscriviti>
